/**
 * Created by Victor Rojo on 11/2/19.
 */
import { Component }     from '@angular/core';

import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryImageSize, NgxGalleryLayout } from 'ngx-gallery';

import {Globals} from "../../globals";

@Component({
  templateUrl: './Surveillance.component.html',
  styleUrls: ['./Surveillance.component.css']
})
export class SurveillanceComponent {
  galleryImages: any;
  galleryOptions: any;
  image = "assets/images/mock_menus/Videovigilancia2.jpg";
  showAsThumbnail = true;
  hasAccess = false;

  constructor(private globals: Globals) {
    this.galleryOptions = [
      {
        width: '300px',
        height: '330px',
        preview: true,
        layout: NgxGalleryLayout.ThumbnailsBottom,
        image: false,
        thumbnailSize: NgxGalleryImageSize.Contain,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
        thumbnails: true,
        previewFullscreen: true,
        previewZoom:true,
        thumbnailsColumns: 1

      }
    ];

    if ( globals.tenant == "ecuador" ) {
      this.showAsThumbnail = false;
    } else if ( globals.tenant == "q8" || globals.tenant == "demoipetrol" || globals.tenant == "ask" ) {
      this.hasAccess = true;
    }

    this.setImage();

    this.galleryImages = [{
      small: this.image,
      medium: this.image,
      big: this.image
    }];
  }

  private setImage(){
    switch (this.globals.tenant){
      case "":
        break;
      case "demoipetrol":
        break;
      case "galp":
        break;
      case "ask":
        this.image = "assets/images/mock_menus/ask/VideocamarasAsk.png";
        break;
      case "ecomanager":
        this.image = "assets/images/mock_menus/ecomotica/videocamarasEco.png";
        break;
      case "hiotera":
        this.image = "assets/images/demo_hiotera/surveilance.png";
        break;
      case "nacexa":
        break;

    }
  }
}
